import { render, staticRenderFns } from "./textarea-input.vue?vue&type=template&id=1cdbc81a&scoped=true"
import script from "./textarea-input.vue?vue&type=script&lang=js"
export * from "./textarea-input.vue?vue&type=script&lang=js"
import style0 from "./textarea-input.vue?vue&type=style&index=0&id=1cdbc81a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdbc81a",
  null
  
)

export default component.exports